import React, { useState } from 'react'
import { Add, AutoFixHighOutlined, PublishRounded } from '@mui/icons-material'
import { observer } from 'mobx-react-lite'
import { Route, Switch, useHistory } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { Header } from '@trivie/ui-web/components/header'

import { TableHelper } from '../../../tables'
import { QuizTable } from '../../../tables/quiz-table'
import { QuizzesDetailsScreen } from './quizzes-details-screen'
import { ImportContentDialog } from '../../../components/dialogs/import-content-dialog'
import { Button } from '@trivie/ui-web/components/button'

export const QuizzesScreen: React.FunctionComponent = observer(() => {
  const { manageUserStore, contentCreationStore } = useStores()
  const history = useHistory()

  const { resetContentStore } = contentCreationStore
  const { permissions, userProfile } = manageUserStore

  const [tableHelper] = useState(new TableHelper('list_quizzes', 'quizzes', 'quizzes'))
  const [importing, setImporting] = useState(false)

  const primary = {
    startIcon: <Add />,
    disabled: !permissions?.permissions.some((p) => p.code === 'can_create_quiz'),
    onClick: () => {
      resetContentStore()
      history.push('/content/creation/quiz/new/edit/?generate=true&create=true')
    },
    text: 'Create Quiz',
  }

  const secondary = {
    disabled: !permissions?.permissions.some((p) => p.code === 'can_create_question'),
    startIcon: <PublishRounded />,
    onClick: () => {
      resetContentStore()
      setImporting(true)
    },
    text: 'Import Quizzes',
  }

  return (
    <Switch>
      <Route exact path="/content/quizzes">
        <Header
          divider
          title="Quizzes"
          // additionalActions={
          //   <Button
          //     sx={{ '&:hover': { opacity: 0.8 } }}
          //     color="gradient"
          //     onClick={() => {
          //       resetContentStore()
          //       history.push('/generate')
          //     }}
          //     disabled={
          //       !permissions?.permissions.some((p) => p.code === 'can_create_quiz') ||
          //       !userProfile?.workspace_settings?.mercury_enabled
          //     }
          //     text="Generate Quiz"
          //     startIcon={<AutoFixHighOutlined />}
          //     data-qat={'generate_quiz_with_ai'}
          //   />
          // }
          primaryAction={primary}
          secondaryAction={secondary}
        />
        <QuizTable tableHelper={tableHelper} />
        {importing && (
          <ImportContentDialog
            title="Import Quizzes"
            intent="Quizzes"
            onClose={() => setImporting(false)}
            open={importing}
          />
        )}
      </Route>
      <Route path="/content/quizzes/:id/:tab">
        <QuizzesDetailsScreen />
      </Route>
    </Switch>
  )
})
